// extracted by mini-css-extract-plugin
module.exports = {"webtrader-description-columns":"WebtraderDescription_webtrader-description-columns__WMpQ9"};